import React, { useEffect, useRef, useState } from 'react';

export interface CompanyViewsProps {
  search: string;
  onSearchChange: (search: string) => void;
}

export const CompanyViews: React.FC<CompanyViewsProps> = (props) => {
  const [term, setTerm] = useState(props.search);
  const debounce = useRef<ReturnType<typeof setTimeout>>(undefined);
  const lastEmitted = useRef(props.search);

  useEffect(() => () => clearTimeout(debounce.current), []);

  // Sync external search changes into the input, but ignore the parent echoing
  // back a value this input just emitted so in-progress typing is never clobbered.
  useEffect(() => {
    if (props.search !== lastEmitted.current) {
      clearTimeout(debounce.current);
      setTerm(props.search);
      lastEmitted.current = props.search;
    }
  }, [props.search]);

  return (
    <div className="flex flex-wrap items-baseline justify-end gap-y-2 pt-2">
      <input
        value={term}
        placeholder="Search companies…"
        onChange={(event) => {
          const { value } = event.target;
          setTerm(value);
          clearTimeout(debounce.current);
          debounce.current = setTimeout(() => {
            lastEmitted.current = value;
            props.onSearchChange(value);
          }, 300);
        }}
        className="w-44 border-b border-rule-faint bg-transparent text-scale-1 text-ink outline-none placeholder:text-ink-muted/60 focus:border-accent"
        aria-label="Search companies"
      />
    </div>
  );
};
